module.exports = __webpack_public_path__ + "static/media/synergycare_logo.3edb72c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/business_group_logos/synergycare_logo.png
// module id = 778
// module chunks = 0